import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Markdown } from '@honda-canada/design-system-react';
import themeStyles from './styles/BrandNotification.styles';
import getFullProductLink from './utils/getFullProductLink';

const MarkdownContent = themeStyles.apply(Markdown, 'Markdown');

const AnotherBrandNotification = ({ productLink, productLine, copyColor }) => {
  const { t } = useTranslation();
  const fullProductLink = getFullProductLink(productLink);
  const notificationMessage = `${t('Sub-apps.Recalls.wrongProductLineSearchLabel', { productLine })} 
  [${t('Sub-apps.Recalls.vinRecallUpdateLinkLabel', { productLine })}](${fullProductLink})`;

  return (
    <MarkdownContent size="small" color={copyColor} fontFamily="bold" data-testid="cy-product-line-message">
      {notificationMessage}
    </MarkdownContent>
  );
};

AnotherBrandNotification.propTypes = {
  copyColor: PropTypes.string.isRequired,
  productLink: PropTypes.string.isRequired,
  productLine: PropTypes.string.isRequired,
};

export default AnotherBrandNotification;
